import { render, staticRenderFns } from "./ICEmpower.vue?vue&type=template&id=6244c4c3&scoped=true&"
import script from "./ICEmpower.vue?vue&type=script&lang=js&"
export * from "./ICEmpower.vue?vue&type=script&lang=js&"
import style0 from "./ICEmpower.vue?vue&type=style&index=0&id=6244c4c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244c4c3",
  null
  
)

export default component.exports